// api/token.js
// トークン取得APIの実装をする

import axios from 'axios'
import HOST from './hosts'
import Api from './api_base'

// トークンの取得は リクエストヘッダの Authorization: Berar が無用
// リクエストの基本設定を記述する
let api = axios.create({
  'baseURL': HOST
})
export default {
  // POST /token ユーザ認証を行い，トークンを発行する
  /**
   * @arg {Object} creds - {id:String, password: String}
   */
  post: (creds, cb) => {
    let params = {
      'id': creds.id,
      'password': creds.password
    }

    return api.post('/token', params)
  },
  // GET /token/validity トークンが有効かどうかを取得する
  getValidity: () => {
    return Api.get('/token/validity')
  }
}



// WEBPACK FOOTER //
// ./src/api/token.js